import React, { ReactNode } from "react";
import {
  PrimaryButton,
  IconButton,
  createClasses,
} from "@bloomberg/media-ui-core";
import styles from "./styles.module.css";

export type NotificationProps = {
  text: string | string[];
  variant: "default" | "lineBreak";
  title: string;
  actionIcon?: ReactNode;
  actionText?: string;
  className?: string;
  onActionClick?: () => void;
};

export default function Notification(props: NotificationProps) {
  const { text, actionIcon, actionText, variant, className, onActionClick } =
    props;

  return (
    <div
      className={createClasses(styles.notification, styles[variant], className)}
    >
      <div className={createClasses(styles.textWrapper, styles[variant])}>
        {Array.isArray(text) ? (
          text.map((line, idx) => <div key={idx}>{line}</div>)
        ) : (
          <div>{text}</div>
        )}
      </div>
      {(actionIcon || actionText) && (
        <div className={styles.buttonWrapper}>
          <PrimaryButton
            className={createClasses(styles.button, styles[variant])}
            Icon={actionIcon}
            color="neutral"
            colorMode="light"
            iconPosition="left"
            size="small"
            version="phoenix"
            onClick={onActionClick}
            title={actionText}
          >
            {actionText}
          </PrimaryButton>
          <IconButton
            className={createClasses(styles.buttonIcon, styles[variant])}
            Icon={actionIcon}
            version="phoenix"
            onClick={onActionClick}
          />
        </div>
      )}
    </div>
  );
}
